import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from "./footer";
import Header from "./header";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { notilist, notistatus, pushnotilist, pushnotistatus } from '../service/dashboard';
import moment from 'moment';



const groupByDate = (notifications) => {
    const grouped = {};
    notifications.forEach((item) => {
        const date = moment(item.created_at);
        let label;
        if (date.isSame(moment(), 'day')) {
            label = 'Today';
        } else if (date.isSame(moment().subtract(1, 'days'), 'day')) {
            label = 'Yesterday';
        } else {
            label = date.format('MMMM D, YYYY');
        }
        if (!grouped[label]) grouped[label] = [];
        grouped[label].push(item);
    });
    return grouped;
};

const PUSH_TYPE_LABEL = {
    attendance: 'Attendance',
    transportattendance: 'Transport',
};

// Audio notifications are stored on the API server (noti_file = "audio/<name>")
// and served by /api/audio/{filename}; every other attachment lives in the
// bucket under the academy's notification folder.
const notiFileUrl = (item, filePath) =>
    item.audio_url ? item.audio_url : `${filePath}${item.noti_file}`;

const notiFileName = (item) => (item.noti_file || '').split('/').pop();

// A plain <a download> is ignored for cross-origin URLs, so pull the file down
// as a blob first and fall back to opening it if that fails.
const downloadNotiFile = async (url, filename) => {
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename || 'download';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (e) {
        window.open(url, '_blank', 'noreferrer');
    }
};

const TrackingNotification = () => {
    const [activeTab, setActiveTab] = useState('general');
    const [generalNotis, setGeneralNotis] = useState([]);
    const [attendanceNotis, setAttendanceNotis] = useState([]);
    const [homeworkNotis, setHomeworkNotis] = useState([]);
    const [filePath, setFilePath] = useState('');

    useEffect(() => {
        loadGeneral();
        loadAttendance();
        loadHomework();
    }, []);

    function loadGeneral() {
        const temp = new FormData();
        const academyId = localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
        if (academyId) temp.append("academy_id", academyId);
        notilist(temp).then((res) => {
            if (res.status === true) {
                setFilePath(res.data.path || '');
                setGeneralNotis(groupByDate(res.data.details));
            }
        });
    }

    function loadAttendance() {
        Promise.all([
            pushnotilist('Attendance'),
            pushnotilist('TransportAttendance'),
        ]).then(([attendRes, transportRes]) => {
            const combined = [
                ...(attendRes?.status === true ? attendRes.data.details : []),
                ...(transportRes?.status === true ? transportRes.data.details : []),
            ]
            .filter(item => ['attendance', 'transportattendance'].includes((item.push_type || '').toLowerCase()))
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setAttendanceNotis(groupByDate(combined));
        });
    }

    function changeGeneralStatus(id, read) {
        if (read === 0) {
            setGeneralNotis([]);
            notistatus(id).then((res) => {
                if (res.status === true) loadGeneral();
            });
        }
    }

    function loadHomework() {
        pushnotilist('Homework').then((res) => {
            if (res?.status === true) {
                const filtered = (res.data.details || []).filter(
                    item => (item.push_type || '').toLowerCase() === 'homework'
                );
                setHomeworkNotis(groupByDate(filtered));
            }
        });
    }

    function changeAttendanceStatus(id, read) {
        if (read === 0) {
            pushnotistatus(id).then((res) => {
                if (res.status === true) loadAttendance();
            });
        }
    }

    function changeHomeworkStatus(id, read) {
        if (read === 0) {
            pushnotistatus(id).then((res) => {
                if (res.status === true) loadHomework();
            });
        }
    }

    const renderGeneralItems = () =>
        Object.entries(generalNotis).map(([label, items]) => (
            <div key={label}>
                <h5 className="mt-4">{label}</h5>
                {items.map((item) => (
                    <div
                        key={item.id}
                        className={`card mb-3 ${item.notification_read === 0 ? 'event-card-active' : 'event-card'}`}
                        onClick={() => changeGeneralStatus(item.id, item.notification_read)}
                    >
                        <Row>
                            <Col xs={3}>
                                <div className="morecontent-inner">
                                    <img
                                        src={require("../assets/images/placeholder.png")}
                                        alt="notification"
                                        className="profileimg"
                                    />
                                </div>
                            </Col>
                            <Col className='upcommingclass'>
                                <strong>{item.title}</strong><br />
                            </Col>
                            <Col xs={3} className="text-end">
                                <small className="event-date">
                                    {moment(item.created_at).format('hh:mm A')}
                                </small>
                            </Col>
                            <Col xs={12}>
                                <p>{item.message}</p>
                                {item.audio_url && (
                                    <audio controls src={item.audio_url} style={{ width: '100%', marginTop: '8px' }} onClick={(e) => e.stopPropagation()} />
                                )}
                                {item.noti_file && (
                                    <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }} onClick={(e) => e.stopPropagation()}>
                                        {!item.audio_url && (
                                            <a
                                                href={notiFileUrl(item, filePath)}
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                    padding: '5px 12px', borderRadius: '6px',
                                                    background: '#6259ca', color: '#fff',
                                                    fontSize: '13px', textDecoration: 'none',
                                                }}
                                            >
                                                <i className="fas fa-eye"></i> View
                                            </a>
                                        )}
                                        <button
                                            type="button"
                                            onClick={() => downloadNotiFile(notiFileUrl(item, filePath), notiFileName(item))}
                                            style={{
                                                display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                padding: '5px 12px', borderRadius: '6px',
                                                background: '#19b159', color: '#fff',
                                                fontSize: '13px', border: 'none',
                                            }}
                                        >
                                            <i className="fas fa-download"></i> Download
                                        </button>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>
                ))}
            </div>
        ));

    const renderAttendanceItems = () =>
        Object.entries(attendanceNotis).map(([label, items]) => (
            <div key={label}>
                <h5 className="mt-4">{label}</h5>
                {items.map((item) => {
                    const typeKey = (item.push_type || '').toLowerCase();
                    const typeLabel = PUSH_TYPE_LABEL[typeKey] || item.push_type;
                    const isUnread = item.push_read === 0;
                    return (
                        <div
                            key={item.id}
                            className={`card mb-3 ${isUnread ? 'event-card-active' : 'event-card'}`}
                            onClick={() => changeAttendanceStatus(item.id, item.push_read)}
                        >
                            <Row>
                                <Col xs={3}>
                                    <div className="morecontent-inner">
                                        <img
                                            src={require("../assets/images/placeholder.png")}
                                            alt="notification"
                                            className="profileimg"
                                        />
                                    </div>
                                </Col>
                                <Col className='upcommingclass'>
                                    <strong>{item.title}</strong><br />
                                    {typeLabel && (
                                        <span style={{
                                            fontSize: '11px',
                                            background: typeKey === 'transportattendance' ? '#17a2b8' : '#28a745',
                                            color: '#fff',
                                            borderRadius: '4px',
                                            padding: '1px 6px',
                                        }}>
                                            {typeLabel}
                                        </span>
                                    )}
                                </Col>
                                <Col xs={3} className="text-end">
                                    <small className="event-date">
                                        {moment(item.created_at).format('hh:mm A')}
                                    </small>
                                </Col>
                                <Col xs={12}>
                                    <p>{item.push_message}</p>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        ));

    const renderHomeworkItems = () =>
        Object.entries(homeworkNotis).map(([label, items]) => (
            <div key={label}>
                <h5 className="mt-4">{label}</h5>
                {items.map((item) => {
                    const isUnread = item.push_read === 0;
                    return (
                        <div
                            key={item.id}
                            className={`card mb-3 ${isUnread ? 'event-card-active' : 'event-card'}`}
                            onClick={() => changeHomeworkStatus(item.id, item.push_read)}
                        >
                            <Row>
                                <Col xs={3}>
                                    <div className="morecontent-inner">
                                        <img
                                            src={require("../assets/images/placeholder.png")}
                                            alt="homework"
                                            className="profileimg"
                                        />
                                    </div>
                                </Col>
                                <Col className="upcommingclass">
                                    <strong>{item.title}</strong><br />
                                    <span style={{
                                        fontSize: '11px',
                                        background: '#f7b731',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        padding: '1px 6px',
                                    }}>
                                        Homework
                                    </span>
                                </Col>
                                <Col xs={3} className="text-end">
                                    <small className="event-date">
                                        {moment(item.created_at).format('hh:mm A')}
                                    </small>
                                </Col>
                                <Col xs={12}>
                                    <p>{item.push_message}</p>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        ));

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <Container>
                    <ul className="nav nav-tabs mt-3 mb-2">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'general' ? 'active' : ''}`}
                                onClick={() => setActiveTab('general')}
                            >
                                General
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'attendance' ? 'active' : ''}`}
                                onClick={() => setActiveTab('attendance')}
                            >
                                Attendance
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'homework' ? 'active' : ''}`}
                                onClick={() => setActiveTab('homework')}
                            >
                                Homework
                            </button>
                        </li>
                    </ul>

                    {activeTab === 'general' && (
                        Object.keys(generalNotis).length === 0
                            ? <p className="text-center text-muted mt-4">No notifications</p>
                            : renderGeneralItems()
                    )}

                    {activeTab === 'attendance' && (
                        Object.keys(attendanceNotis).length === 0
                            ? <p className="text-center text-muted mt-4">No attendance notifications</p>
                            : renderAttendanceItems()
                    )}

                    {activeTab === 'homework' && (
                        Object.keys(homeworkNotis).length === 0
                            ? <p className="text-center text-muted mt-4">No homework notifications</p>
                            : renderHomeworkItems()
                    )}
                </Container>

                <div className="bottom-nav">
                    <i className="fas fa-home"></i>
                    <i className="fas fa-map-marker-alt"></i>
                    <i className="fas fa-user"></i>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TrackingNotification;
